import { render, staticRenderFns } from "./app-event-card.vue?vue&type=template&id=3fc7c6bd&scoped=true&"
import script from "./app-event-card.vue?vue&type=script&lang=js&"
export * from "./app-event-card.vue?vue&type=script&lang=js&"
import style0 from "./app-event-card.vue?vue&type=style&index=0&id=3fc7c6bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc7c6bd",
  null
  
)

export default component.exports